import { useState, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Login from '../pages/auth/Login';
import LoadingScreen from '#/components/shared/ui/LoadingScreen';
import useAuth from '../lib/hooks/useAuth';
import Auth from '../layout/auth';

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return (
      <Auth>
        <Login />
      </Auth>
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return children;
}
